<template>
	<div class="loadItem">
		<div class="loadHead">
			<div class="title">Payments</div>
			<div class="contract_btn">
				<button @click="onAddItem" type="button" class="mainBtn mainBtn-text">
          <span class="btnIco">
              <svg-sprite icon-id="plus" width="20" height="20"></svg-sprite>
          </span>
					<span class="btnText">Add payment</span>
				</button>
			</div>
		</div>
		<div class="paymentHead">
			<div class="paymentHead_item">
				<span class="text">Rate:</span>
				<span class="icon"><svg-sprite icon-id="icon_dollars" width="8" height="14"></svg-sprite></span>
				<span class="value">{{ load.rate }}</span>
			</div>
			<div class="paymentHead_item">
				<span class="text">Total:</span>
				<span class="icon"><svg-sprite icon-id="icon_dollars" width="8" height="14"></svg-sprite></span>
				<span class="value">{{ load.gross }}</span>
			</div>
		</div>

		<div
				class="loadMain"
				v-if="getListItems.length > 0"
		>
			<main-table
					padding="0"
					:flag="flag"
					:headers="getHeaders"
					:listItems="getListItems"
					@updateClickButton="onClickButton($event, flag)"
					@updateClickButtonItemIndex="onClickButtonItemIndex($event, flag)"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
	</div>
</template>

<script>
import { tablePayments, paymentsTypes } from "@/components/Dispatch/Trips/DialogTrip/constants";
// Constants
import { PAGE } from "@/constants/constants";

export default {
	name: "Payments",
	props: {
		load: Object,
	},
	computed: {
		getHeaders() {
			return tablePayments;
		},
		getListItems() {
			const originalArray = this.load.payments;
			const copyArray = originalArray.slice();
			const filteredArray = copyArray.filter(obj => obj.status !== 'delete');

			filteredArray.map(obj => {
				const paymentsType = paymentsTypes.filter(function(val) {
					if (val.id === obj.type) return val;
				});
				obj.typeName = paymentsType[0].value;

				obj.considerBoolean = obj.consider === 1;
			});
			return filteredArray;
		},
	},
	data() {
		return {
			flag: PAGE.TRIP_PAYMENTS,
			loadTotal: null,
			itemIndex: null
		};
	},
	methods: {
		onAddItem() {
			this.$emit('updateAddItem', this.flag);
		},
		onClickButtonItemIndex(index) {
			this.itemIndex = index;
		},
		onClickButton(args, nameComponent) {
			const { key, item } = args;
			const itemIndex = this.itemIndex;
			this.$emit('updateEditItem', { key, item, nameComponent, itemIndex });
		},
	},
};
</script>
<style lang="scss">
.loadMain {
	.pagination {
		padding: 20px 0 10px;
	}
}
</style>
<style scoped lang="scss">
@import "../loadItem";
@import "payments";
</style>
